import React from "react";
import {} from //Notification,
//IncomingCallNotification,
// useTheme,
"@azure/communication-react";
import {
  makeStyles,
  //START: list
  tokens,
  List,
  ListItem,
  Body1,
  Caption1,
  Link,
  shorthands,
  mergeClasses,
  //END: list
} from "@fluentui/react-components";

import IncomingCallToast from "./IncomingCall/IncomingCallToast";

const useStyles = makeStyles({
  wrapper: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  //START: list
  listRoot: {
    width: "auto", //"100%",
    ...shorthands.padding("0", "0"),
  },

  listItem: {
    padding: "0.85rem",
    borderBottom: "1px solid var(--neutralStroke2, #e1e1e1)",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground4,
      //color: tokens.colorNeutralForeground1,
    },
  },

  listItemGrid: {
    display: "grid",
    gridTemplateColumns: "80% 20%",
    gap: 12,
    alignItems: "center",
  },

  // -------- Column 1 --------
  col1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconLarge: {
    fontSize: "32px",
    lineHeight: "1",
  },

  // -------- Column 2 --------
  textDecorWithUnderline: {
    //to always show underline under record name
    textDecoration: "underline",
    textDecorationColor: "currentColor",
  },
  boldText: {
    fontWeight: "bold",
  },
  required: {
    color: "rgb(194, 57, 52)",
  },
  col2: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    overflow: "hidden",
  },

  col2Row1: {
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },

  nameLink: {
    color: "inherit",
    textDecoration: "none",
    minWidth: 0,
    display: "inline-block",
  },

  col2Row2: {
    fontSize: "0.85rem",
    color: "var(--neutralForeground2, #605E5C)",
  },

  // -------- Column 3 --------
  col3: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
    gap: 4,
  },

  col3Row1: {
    fontSize: "18px",
    lineHeight: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  col3Row2: {
    color: "var(--neutralForeground3, #605E5C)",
    fontWeight: 200,
    cursor: "pointer",
    ":hover": {
      textDecoration: "underline",
      color: tokens.colorNeutralForeground1,
    },
  },

  editLink: {
    color: "var(--neutralForeground3, #605E5C)",
    textDecoration: "none",
    fontWeight: 500,
    cursor: "pointer",
    ":hover": {
      color: tokens.colorNeutralForeground1,
    },
  },

  queueLine: {
    color: "var(--neutralForegroundDisabled, #8a8886)",
  },
  //END: list
});

export const IncomingNotification = React.memo(
  ({ incomingCallMap, showIncomingRing, onAcceptCall, onHangUp }) => {
    return (
      <IncomingCallToast
        onClickAccept={onAcceptCall}
        onClickReject={onHangUp}
        incomingCallMap={incomingCallMap}
        showIncomingRing={showIncomingRing}
      />
    );
  },
);
